import { Box, Container, Typography, Grid, Paper } from '@mui/material';
import { WorkOutline, School, TrendingUp, Support } from '@mui/icons-material';
import { motion } from 'framer-motion';

const WhyChooseMe = () => {
  const reasons = [
    {
      icon: <WorkOutline />,
      title: 'Step-by-step Roadmap',
      description: 'Get a clear, actionable plan to grow your tax prep business'
    },
    {
      icon: <School />,
      title: 'Personalized Coaching',
      description: 'One-on-one guidance addressing your unique challenges'
    },
    {
      icon: <TrendingUp />,
      title: 'Proven Tools & Resources',
      description: 'Access the same tools and strategies that have helped my clients succeed'
    },
    {
      icon: <Support />,
      title: 'Ongoing Support',
      description: 'Stay on track with continuous guidance as you scale your business'
    }
  ];

  return (
    <Box id="why-choose-me" sx={{ py: 8, bgcolor: 'background.default' }}>
      <Container maxWidth="lg">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <Typography
            component="h2"
            variant="h3"
            align="center"
            color="text.primary"
            gutterBottom
            sx={{ mb: 6 }}
          >
            Why I'm the Right Person to Help You Start Your Tax Business
          </Typography>

          <Paper elevation={0} sx={{ p: 4, bgcolor: 'transparent' }}>
            <Typography variant="body1" paragraph sx={{ mb: 4 }}>
              Starting a tax preparation business can feel overwhelming, but I'm here to simplify the process. 
              I've built a successful tax business from the ground up, worked at <strong>Intuit as a team lead</strong>, 
              and helped countless professionals grow their own businesses. I know exactly what works—and what doesn't—and 
              I'll help you avoid the mistakes that slow down most new business owners.
            </Typography>

            <Grid container spacing={4}>
              {reasons.map((reason, index) => (
                <Grid item xs={12} sm={6} key={index}>
                  <motion.div
                    initial={{ opacity: 0, x: index % 2 === 0 ? -20 : 20 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.5, delay: index * 0.1 }}
                  >
                    <Paper 
                      elevation={2} 
                      sx={{ 
                        p: 3, 
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        textAlign: 'center',
                        '&:hover': {
                          transform: 'translateY(-4px)',
                          transition: 'transform 0.3s ease-in-out',
                        },
                      }}
                    >
                      <Box 
                        sx={{ 
                          p: 2, 
                          bgcolor: 'primary.main',
                          borderRadius: '50%',
                          mb: 2,
                          color: 'white'
                        }}
                      >
                        {reason.icon}
                      </Box>
                      <Typography variant="h6" component="h3" gutterBottom>
                        {reason.title}
                      </Typography>
                      <Typography>{reason.description}</Typography>
                    </Paper>
                  </motion.div>
                </Grid>
              ))}
            </Grid>

            <Typography variant="body1" sx={{ mt: 4, textAlign: 'center' }}>
              When you invest in my coaching packages, you're not just getting resources—you're getting 
              <strong> years of experience</strong>, insider knowledge, and the personalized attention you need to succeed.
            </Typography>
          </Paper>
        </motion.div>
      </Container>
    </Box>
  );
};

export default WhyChooseMe;
